import { useState } from "react";

import { VirtualSiteGroupCreateForm } from "src/app/features/VirtualSiteGroup/components/forms/VirtualSiteGroupCreateForm";
import { ActionBar } from "../../../../components/ActionBar/ActionBar";
import { PageTitle } from "../../../../components/AppLayout/components/Content/components";
import { FPage, FPageContent, FPageHeader } from "../../../../components/AppLayout/components/FPageLayout";
import { BackButton } from "../../../../components/FeatureButtons/BackButton";
import { SubmitButton } from "../../../../components/FeatureButtons/SubmitButton";
import { ResourceName } from "../../../../core/router/config/ResourceName";
import { BASE_PATH } from "../../../../core/router/types/routerTypes";

export const VirtualSiteGroupCreateFormPage = () => {
    const [runSubmit, setRunSubmit] = useState(0);
    const triggerFormSubmit = () => setRunSubmit(runSubmit + 1);

    return (
        <FPage>
            <FPageHeader>
                <PageTitle translationKey="page.title.VirtualSiteGroupCreateFormPage" />
                <ActionBar>
                    <SubmitButton isDisabled={false} onClick={triggerFormSubmit} />
                    <BackButton isDisabled={false} url={`${BASE_PATH}/${ResourceName.VIRTUAL_SITE_GROUPS}`} />
                </ActionBar>
            </FPageHeader>
            <FPageContent>
                <VirtualSiteGroupCreateForm runSubmit={runSubmit} />
            </FPageContent>
        </FPage>
    );
};
